import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

class OrderSummaryTotal extends PureComponent {
  static propTypes = {
    headingClass: PropTypes.string,
    extraClass: PropTypes.string,
    title: PropTypes.string,
    primaryInfo: PropTypes.string,
    planRate: PropTypes.string,
    planUpfront: PropTypes.string,
    planInterval: PropTypes.string,
    children: PropTypes.node,
  }

  static defaultProps = {
    headingClass: null,
    extraClass: null,
    planRate: '0.00',
    planUpfront: '0.00',
    planInterval: '0.00',
    title: null,
    primaryInfo: '',
    children: null,
  }

  render() {
    const {
      title,
      primaryInfo,
      headingClass,
      extraClass,
      planRate,
      planInterval,
      planUpfront,
    } = this.props

    let primaryInfoVar = primaryInfo
    const placeHolders = [
      {
        tag: '[PLAN_RATE]',
        value: `$${planRate}`,
      },
      {
        tag: '[PLAN_INTERVAL]',
        value: planInterval,
      },
      {
        tag: '[UPFRONT_COST]',
        value: `$${planUpfront}`,
      },
    ]
    placeHolders.forEach((placeHolder) => {
      primaryInfoVar = primaryInfoVar.replace(placeHolder.tag, placeHolder.value)
    })

    if (title === null || primaryInfo === null) {
      return null
    }
    return (
      <div className={extraClass}>
        <div className={styles.wrapper}>
          <div className={headingClass}>{title}</div>
          <div
            className={styles.primaryInfo}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: primaryInfoVar }}
          />
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default OrderSummaryTotal



// WEBPACK FOOTER //
// ./components/OrderSummaryTotal/index.jsx